export default "__VITE_ASSET__CFg2sUO1__"